import { Entity } from '@data-client/rest';
import { ISODate } from '../utils/transforms';
class UserEntity extends Entity {
    constructor() {
        super(...arguments);
        this.creationDTTM = new Date(0);
        this.deletionEnabled = false;
        this.email = null;
        this.firstName = null;
        this.geoCountryId = null;
        this.geoCountryName = null;
        this.id = null;
        this.isLicenseDefault = false;
        this.isLicenseUpgradeable = false;
        this.isLockedOut = false;
        this.isTrial = false;
        this.lastName = null;
        this.licenseExpirationDTTM = null;
        this.lockoutExpiration = null;
        this.organizationId = null;
        this.organizationLicenseTypeId = null;
        this.organizationLicenseTypeName = null;
        this.organizationRoleId = null;
        this.organizationRoleName = null;
        this.phoneNumber = null;
        this.twoFactorEnabled = false;
        this.twoFactorExists = false;
        this.userStatusId = null;
        this.userStatusName = null;
    }
    pk() {
        var _a;
        return ((_a = this.id) === null || _a === void 0 ? void 0 : _a.toString()) || btoa(JSON.stringify(this));
    }
}
UserEntity.schema = {
    creationDTTM: ISODate,
    lockoutExpiration: ISODate,
    licenseExpirationDTTM: ISODate
};
UserEntity.key = 'User';
export { UserEntity };
